import { Typography } from '@design-system/components/typography/typography';
import { BundleDetailsCard } from './BundleDetailsCard';
import { BundlesContentTable } from './BundlesContentTable';
import { BundlesCards } from '../viewModel/subscriptionBundle.vm.mapper';
import { SubscriptionBundlesVM } from '../viewModel/subscriptionBundles.viewModel';
import { SubscriptionPriceModal } from './editBundle/SubscriptionPriceModal';
import { ConfirmPriceChangeModal } from './ConfirmPriceChangeModal';
import { ConfirmPriceDisableModal } from './ConfirmPriceDisableModal';

export type SubscriptionBundlesProps = {
  cards: BundlesCards;
  showSubscriptionBundles: boolean;
} & Pick<
  SubscriptionBundlesVM,
  'list' | 'priceEditModal' | 'confirmPriceModal' | 'confirmPriceDisableModal'
>;

export const SubscriptionBundles = ({
  cards,
  showSubscriptionBundles,
  priceEditModal,
  confirmPriceModal,
  confirmPriceDisableModal,
  ...p
}: SubscriptionBundlesProps) => {
  if (!showSubscriptionBundles) return null;

  return (
    <div className="flex flex-col gap-6">
      <div className="flex justify-between items-center">
        <Typography variant="body" size="medium" color="N-80">
          Subscription Offers
        </Typography>
      </div>

      <div className="flex flex-col gap-4">
        <div className="grid grid-rows-2 md:grid-cols-2 md:grid-rows-1 gap-4 w-full">
          {cards.map((card) => (
            <BundleDetailsCard {...card} key={card.bundleId} />
          ))}
        </div>
        <BundlesContentTable {...p} />
      </div>
      <SubscriptionPriceModal {...priceEditModal} />
      <ConfirmPriceChangeModal {...confirmPriceModal} />
      <ConfirmPriceDisableModal {...confirmPriceDisableModal} />
    </div>
  );
};
